const assert = require('Assert');
const SoundMapEntry = require('SoundMapEntry');
const AudioPlayOption = require('AudioPlayOption');

const DEFAULT_SOUND_VOLUME = 0.5;

const Events = {
    load: 'load',
    play: 'play',
    end: 'end'
};

const DEFAULT_PLAY_OPTION = new AudioPlayOption();

// TODO refactor this. some functions must be broken down to separate functions
// TODO support multiple audio sprite (loadscene, gamescene, featurescene)

cc.Class({
    extends: cc.Component,

    statics: {
        Events
    },

    properties: {
        audioSprite: {
            type: cc.AudioClip,
            default: null,
            visible: false,
            serializable: false
        },
        audioSpriteJson: {
            type: cc.JsonAsset,
            default: null,
            visible: false,
            serializable: false
        },
        maxMusicSimultaneously:
        {
            type: cc.Integer,
            min: 1,
            max: 10,
            step: 1,
            default: 10
        },
        audioSettingJson: {
            type: cc.JsonAsset,
            default: null
        }
    },

    ctor () {
        this.musicEnabled = false;
        this.sfxEnabled = false;

        this.musicVolume = 1;
        this.sfxVolume = 1;
        this.volume = 1;

        this.loadedSoundSettings = {};

        this.isGameVisible = true;

        /**
         * Maps for keeping track of what Audioclip is active and storing callbacks
         */
        this.mapMusic = new Map();
        this.mapSfx = new Map();

        // this._initAudioLoadHandlers();
        const urlSearchParams = new URLSearchParams(window.location.search);
        const active = true; //TODO add launcher param cheatModePSConfig.get().cheatMode === PSConfig.CheatModes.Active;
        if ((active && urlSearchParams.get('audio') === 'true')) {
            this._audioPanelActive = true;
        }
    },

    onLoad () {
        cc.game.addPersistRootNode(this.node);

        this._registerWindowCallbacks();

        if (this.audioSettingJson !== null) {
            for (const audio in this.audioSettingJson.json) {
                if (typeof audio === 'string') {
                    this.loadedSoundSettings[audio] =
                        cc.js.mixin(this.loadedSoundSettings[audio],
                            this.audioSettingJson.json[audio]);
                }
            }

        }
    },

    _initAudioLoadHandlers () {
        const audioTypes = [
            // types supported by COCOS
            'mp3',
            'ogg',
            'wav',
            'm4a'

            // supported by Howler
            // TODO if needed
            // "mpeg", "opus",  "oga",  "aac", "caf", mp4", "weba", "webm", "dolby", "flac"
        ];
        const mapLoadExt = {};

        audioTypes.forEach((type) => {

            mapLoadExt[type] = (item) => {
                /* eslint-disable  no-underscore-dangle */
                const loadByDeserializedAsset = (item._owner instanceof cc.Asset);

                if (loadByDeserializedAsset) {
                    // already has cc.Asset
                    this._handleSoundLoad(item._owner);

                    return null;
                }

                const audioClip = new cc.AudioClip();

                audioClip._setRawAsset(item.rawUrl, false);
                audioClip._nativeAsset = item.content;
                audioClip.url = item.url;

                this._handleSoundLoad(item._owner);
                /* eslint-enable  no-underscore-dangle */

                return audioClip;
            };

        });

        // check if we are in cocos 2.4.x where it uses cc.assetManager
        if (cc.assetManager) {
            cc.assetManager.parser.register(mapLoadExt);
        } else {
            cc.loader.addLoadHandlers(mapLoadExt);
        }
    },

    registerEvent (evt, cb, ctx) {
        this.node.on(evt, cb, ctx);
    },

    _handleSoundLoad (audioClip) {
        if (CC_EDITOR) {
            return;
        }

        if (!this.loadedSoundSettings) {
            this.loadedSoundSettings = {};
        }

        if (this.loadedSoundSettings.hasOwnProperty(audioClip.name)) {
            this.loadedSoundSettings[audioClip.name].volume =
                typeof this.loadedSoundSettings[audioClip.name].volume !== 'undefined' ?
                    this.loadedSoundSettings[audioClip.name].volume : DEFAULT_SOUND_VOLUME;
        } else {
            this.loadedSoundSettings[audioClip.name] = {
                volume: DEFAULT_SOUND_VOLUME
            };
        }

        this.loadedSoundSettings[audioClip.name].clip = audioClip;

        this.node.emit(Events.load, audioClip);
    },

    _handleAudioSpriteLoad (audioClip, json) {
        this.audioSprite = audioClip;
        this.audioSpriteJson = json;

        if (!this.loadedSoundSettings) {
            this.loadedSoundSettings = {};
        }

        for (const key in json.sprite) {
            if (typeof key !== 'string') {
                continue;
            }

            const keyName = `sprite:${key}`;

            if (this.loadedSoundSettings.hasOwnProperty(keyName)) {
                this.loadedSoundSettings[keyName].volume =
                    typeof this.loadedSoundSettings[keyName].volume !== 'undefined' ?
                        this.loadedSoundSettings[keyName].volume : DEFAULT_SOUND_VOLUME;
            } else {
                this.loadedSoundSettings[keyName] = {
                    volume: DEFAULT_SOUND_VOLUME
                };
            }

            this.loadedSoundSettings[keyName].clip = audioClip;
            this.loadedSoundSettings[keyName].isSprite = true;
        }

        this.node.emit(Events.load, audioClip);
    },

    /**
     * Get the sound mix settings by its audio name
     * @param {*} audioName name of the audio clip to get sound settings of. If it is a audio sprite.
     * Append 'sprite:' to the name
     */
    getSoundMixVolume (audioName) {
        if (this.loadedSoundSettings.hasOwnProperty(audioName)) {
            return this.loadedSoundSettings[audioName];
        }

        return null;
    },

    _ensureSoundSettings (audio, spriteName = null) {
        let idx = null;

        if (cc.js.isString(spriteName)) {
            idx = `sprite:${spriteName}`;
        } else if (audio instanceof cc.AudioClip) {
            idx = audio.name;
        } else {
            cc.warn('invalid values');

            return null;
        }

        if (typeof this.loadedSoundSettings[idx] === 'undefined') {
            this.loadedSoundSettings[idx] = {
                volume: DEFAULT_SOUND_VOLUME,
                clip: audio
            };
        }

        return this.loadedSoundSettings[idx];
    },

    /**
     * Callbacks for window events is registered here
     */
    _registerWindowCallbacks () {
        cc.game.on(cc.game.EVENT_HIDE, this._handleVisibilityChange.bind(this, false));
        cc.game.on(cc.game.EVENT_SHOW, this._handleVisibilityChange.bind(this, true));
    },

    onDestroy () {
        cc.game.off(cc.game.EVENT_HIDE, this._handleVisibilityChange.bind(this, false));
        cc.game.off(cc.game.EVENT_SHOW, this._handleVisibilityChange.bind(this, true));
    },

    _handleVisibilityChange (isVisible) {
        if (isVisible) {
            this.resumeMusic();
            this.resumeEffects();

            // this.unmuteSfx();
            // this.unmuteMusic();
            this.isGameVisible = isVisible;
        } else if (!isVisible) {
            this.pauseMusic();
            this.pauseEffects();

            this.muteSfx();
            this.muteMusic();

            this.isGameVisible = isVisible;
        }

        // cc.log(`browser is ${  isVisible}`);
    },

    /**
     * CUI open event is should be handled by this function
     */
    handleCUIOpen () {
        this.isCUIOpened = true;
        this.pauseEffects();
    },

    /**
     * CUI close event is should be handled by this function
     */
    handleCUIClose () {
        this.isCUIOpened = false;
        this.resumeEffects();
    },

    /**
     * Setting up the global volume
     * @param {Number} value between 0.0 ~ 1.0
     */
    setGlobalVolume (value) {
        if (assert.isNull(value)) {
            return;
        }

        value /= 10;
        if (assert.numberRange(value, 0, 1)) {
            this.volume = value;
            this.updateVolume();
        }
    },

    /**
     * return global volume value (0.0 ~ 1.0)
     */
    getGlobalVolume () {
        return this.volume;
    },

    /**
     * Update sound volumes for both music and sfx sounds
     * TODO break this up into two functions!
     */
    updateVolume (isSfxOnly = false, isMusicOnly = false) {
        if (!isMusicOnly) {
            this.mapSfx.forEach((audio) => {
                // this._setSoundVolume(audio.clip, effectValue);
                this.setSoundVolume(audio.clip);
            });
        }

        if (!isSfxOnly) {
            this.mapMusic.forEach((audio) => {
                this.setSoundVolume(audio.clip);
            });
        }

    },

    //////////////////// BACKGROUND MUSIC ///////////////////////
    /**
     * Sets only music's volume (won't affect on sfx volume),
     * @param {Number} volume - the float value between 0.0 - 10.0. This is so, due to the CUI design.
     */
    setMusicVolume (value) {
        if (assert.isNull(value)) {
            return;
        }

        value /= 10;
        if (assert.numberRange(value, 0, 1)) {
            this.musicVolume = value;
            this.updateVolume(false, true);
        }
    },

    /**
     *  return music's volume
     */
    getMusicVolume () {
        return this.musicVolume * this.volume;
    },

    /**
     * set music enabled, stop all musics if the value is false
     * @deprecated for review. intended to be used by CUI but setSoundEnabled() is preferred
     * @param {boolean} value
     */
    setMusicEnabled (value) {
        if (assert.isNull(value)) {
            return;
        }

        if (value && value !== this.musicEnabled) {
            this._resumeSound(value);
        }
        this.musicEnabled = value;
        if (!value) {
            this.stopAllMusic();
        }
    },

    /**
     * intended to be used for CUI integration. see AudioManagerCUI.js for recommended usage.
     * @param {bool} value
     */
    setSoundEnabled (value) {
        if (!assert.isNull(value)) {
            if (!value) {
                // this.pauseMusic();
                // this.pauseEffects();

                this.muteSfx();
                this.muteMusic();

                this.musicEnabled = false;
                this.sfxEnabled = false;
            } else {
                this.musicEnabled = true;
                this.sfxEnabled = true;

                // this.resumeMusic();
                // this.resumeEffects();

                // todo create a container for sounds muted explicitly
                this.unmuteSfx();
                this.unmuteMusic();
            }
        }
    },

    /**
     * return true if music is enabled
     */
    getMusicEnabled () {
        return this.musicEnabled;
    },

    _getSoundMapEntryByAudioId (id, isSfx = false) {
        const it = isSfx ? this.mapSfx.values() : this.mapMusic.values();
        let result = it.next();

        while (!result.done) {

            if (result.value.id === id) {
                return result.value;
            }

            result = it.next();
        }

        return null;
    },

    _handlePlayMusic (audio, trackIndex = 0, loop = true, onAudioEndCallback = null, spriteName = null, volume = 1, sideChain = false) {
        let audioId = null;

        if (!assert.isNull(audio)) {
            this.stopMusic(trackIndex);
            const soundSetting = this._ensureSoundSettings(audio, spriteName);
            const musicValue = this.musicVolume * this.volume *  soundSetting.volume * volume;
            const muted = !this.isGameVisible || !this.musicEnabled;

            const cb = () => {
                if (!loop) {
                    if (onAudioEndCallback !== null) {
                        onAudioEndCallback();
                    }

                    const id = this.mapMusic.get(trackIndex);

                    if (id === audioId) {
                        this.node.emit(Events.end, id);
                        this.mapMusic.delete(trackIndex);
                    }
                }
            };

            if (spriteName !== null) {
                audioId = this._playAudioSprite(audio, spriteName, loop, musicValue, muted, cb, sideChain);
            } else {
                audioId = this._playSound(audio, loop, musicValue, muted, cb, sideChain);
            }

            if (audioId !== null) {
                const soundMapEntry = new SoundMapEntry(audio, audioId, soundSetting, loop, spriteName);

                soundMapEntry.count = loop ? -1 : 1;
                soundMapEntry.cb = onAudioEndCallback;
                soundMapEntry.volume = volume;

                this.mapMusic.set(trackIndex, soundMapEntry);

                this.node.emit(Events.play, soundMapEntry);

                if (muted) {
                    this._muteSound(audioId);
                }
            } else {
                cc.warn(`problem in playing: ${  audio  } ${  spriteName}`);
            }

        }

        return audioId;
    },

    /**
     * Play given music on given track, only one music can be played in each track
     * @param {cc.AudioClip} audio
     * @param {boolean} loop
     * @param {Number} trackIndex track index, only one music can be played in each track
     * @param {function} onAudioEndCallback audio playback has ended
     * @returns {Number} audio id of the music played
     */
    playMusic (audio, trackIndex = 0, loop = true, onAudioEndCallback = null, sideChain) {
        return this._handlePlayMusic(audio, trackIndex, loop, onAudioEndCallback, sideChain);
    },

    playMusicSprite (audio, trackIndex = 0, spriteName, loop = true, onAudioEndCallback = null, sideChain) {
        return this._handlePlayMusic(audio, trackIndex, loop, onAudioEndCallback, spriteName, sideChain);
    },

    /**
     * Stop music on a given track
     * @param {Number} trackIndex track index to be stopped
     * @param {boolean} check if true, do not check/assertd/validate track index
     * @param {function}
     */
    stopMusic (trackIndex = 0, check = true) {
        if (!check || assert.numberLower(trackIndex, this.maxMusicSimultaneously)) {
            let obj;

            do {
                obj = this.mapMusic.get(trackIndex);

                if (obj) {
                    this._stopSound(obj.id);
                    this.node.emit(Events.end, obj);
                    this.mapMusic.delete(trackIndex);
                }
            } while (obj)
        }
    },

    /**
     * Stop all musics and clear track indicies
     */
    stopAllMusic () {
        this.mapMusic.forEach((v) => {
            this._stopSound(v.id);
        });

        this.mapMusic.clear();
    },

    /**
     * Pause all music
     */
    pauseMusic () {
        this.mapMusic.forEach((v) => {
            this._pauseSound(v.id);
        });
    },
    /**
     * Pause music by soundID
     */
    pauseMusicById (soundId) {
        this._pauseSound(soundId);
    },

    /**
     * Resume paused music by sounID
     */
    resumeMusicById (soundId, volume = 1, loop = true) {
        this._resumeSound(soundId, this.musicVolume * this.volume * volume, loop);
        if (!this.musicEnabled) {
            this.muteMusic(soundId);
        }
    },
    /**
     * Resume all paused music
     */
    resumeMusic () {
        this.mapMusic.forEach((v) => {
            this._resumeSound(v.id, v.getVolume() * this.musicVolume * this.volume, v.loop);

            if (!this.musicEnabled) {
                this.muteMusic(v.id);
            } else {
                this.unmuteMusic(v.id);
            }
        });
    },

    ////////////////////// SOUND EFFECTS //////////////////////////
    /**
     * Sets only sfx's volume (won't affect on music volume),
     * @param {Number} volume - the float value between 0.0 ~ 1.0
     */
    setSfxVolume (volume) {
        volume /= 10;
        if (assert.numberRange(volume, 0, 1)) {
            this.sfxVolume = volume;
            this.updateVolume(true, false);
        }
    },

    /**
     * return sfx volume, number between 0.0 ~ 1.0
     */
    getSfxVolume () {
        return this.sfxVolume * this.volume;
    },

    /**
     * set sfx enabled, stop all sfx sounds if the value is false
     * @deprecated for review. intended to be used by CUI but setSoundEnabled() is preferred
     * @param {boolean} value
     */
    setSfxEnabled (value) {
        this.sfxEnabled = value;
        if (!value) {
            this.stopAllSfx();
        }
    },

    // check if sfx is enabled
    getSfxEnabled () {
        return this.sfxEnabled;
    },

    // eslint-disable-next-line max-statements
    _handlePlaySfx (audio, count = 1, onAudioEndCallback = null, spriteName = null, volume = 1, sideChain = false) {
        let audioId = null;

        if (!assert.isNull(audio)) {
            const soundSetting = this._ensureSoundSettings(audio, spriteName);
            const effectValue = (this.sfxVolume * this.volume) * soundSetting.volume * volume;
            const isLoop = count < 1 || count > 1 ? true : false;
            const fixedLoop = count < 1;
            const muted = !this.isGameVisible || !this.sfxEnabled;

            const cb = () => {
                this._unregisterSfx(audioId, fixedLoop);
            };

            if (spriteName !== null) {
                audioId = this._playAudioSprite(audio, spriteName, isLoop, effectValue, muted, cb, sideChain);
            } else {
                audioId = this._playSound(audio, isLoop, effectValue, muted, cb, sideChain);
            }

            if (audioId !== null) {
                const soundMapEntry = new SoundMapEntry(audio, audioId, soundSetting, isLoop, spriteName);

                soundMapEntry.count = count;
                soundMapEntry.cb = onAudioEndCallback;
                soundMapEntry.volume = volume;

                this.mapSfx.set(audioId, soundMapEntry);

                this.node.emit(Events.play, soundMapEntry);

                if (this.isCUIOpened) {
                    this._pauseSound(audioId);
                }
            } else {
                cc.warn(`problem in playing: ${  audio  } ${  spriteName}`);
            }
        }

        return audioId;
    },

    /**
     * Play given audio if sfxSounds are enabled
     * @param {cc.audioClip} audioClip to be played
     * @param {Number} count < 0 loop continuously, 0 do not loop, > 0 repeat sound 'n' times
     * @param {function} onAudioEndCallback for when the sfx has stopped playing
     * @returns {number} audio ID for the played sfx
     */
    playSfx (audioClip, count = 1, onAudioEndCallback = null, volume, sideChain) {
        return this._handlePlaySfx(audioClip, count, onAudioEndCallback, null, volume);
    },

    /**
     * Play given audio if sfxSounds are enabled
     * @param {cc.audioClip} audioClip to be played
     * @param {Number} count < 0 loop continuously, 0 do not loop, > 0 repeat sound 'n' times
     * @param {function} onAudioEndCallback for when the sfx has stopped playing
     * @returns {number} audio ID for the played sfx
     */
    playSfxSprite (audioClip, spriteName, count = 1, onAudioEndCallback = null, volume, sideChain) {
        return this._handlePlaySfx(audioClip, count, onAudioEndCallback, spriteName, volume);
    },

    play(options) {
        const { clip, spriteName, isAudioSprite, volume, musicTrack, loop, count, isMusic, onAudioEndCallback, oneShot, sideChain } = Object.assign(DEFAULT_PLAY_OPTION, options);

        if (oneShot) {
            if (isAudioSprite) {
                return this.playOneShotSprite(this.audioSprite, spriteName, volume, sideChain);
            } else {
                return this.playOneShot(clip, volume, sideChain);
            }
        }

        if (isMusic) {
            return this._handlePlayMusic(isAudioSprite ? this.audioSprite : clip, musicTrack, loop, onAudioEndCallback, isAudioSprite ? spriteName : undefined, volume, sideChain);
        } else {
            return this._handlePlaySfx(isAudioSprite ? this.audioSprite : clip, loop ? -1 : count, onAudioEndCallback, isAudioSprite ? spriteName : undefined, volume, sideChain);
        }
    },

    _unregisterSfx (audioId, isFixedLoop) {
        const obj = this.mapSfx.get(audioId);

        if (obj) {
            if (obj.count > 0 && !isFixedLoop) {
                obj.count--;
                if (obj.count === 1) {
                    this._setLoop(false, audioId);
                }
            }

            if (obj.count <= 0 && !this._isLoop(audioId)) {
                // this._stopSound(audioId);

                if (obj.cb) {
                    obj.cb();
                }

                this.node.emit(Events.end, obj);
                this.mapSfx.delete(audioId);

            }
        }
    },

    /**
     * stop specified audio and call callbacks if available
     * @param {number|cc.audioClip|string} parameter for audio clip to be stopped.
     * @param {boolean} if true, will call the callback assigned if it is available
     */
    stopSfx (audio) {
        const isAudioClip = audio instanceof cc.AudioClip;

        if (!isAudioClip && typeof (audio) === 'number' && !this._isSoundIdSfx(audio)) {
            cc.warn(`audio:[${audio}] is not a sfx`);
            return false;
        }

        const result = this._stopSound(audio);

        if (!result) {
            return false;
        }

        if (isAudioClip) {
            const indices = [];

            this.mapSfx.forEach((v, k) => {
                if (v.clip === audio) {
                    indices.push(k);
                }
            });

            indices.forEach((elem) => {
                this.mapSfx.delete(elem);
            });
        } else if (audio || audio >= 0) {
            this.mapSfx.delete(audio);
        }
    },

    /**
     * stop all playing sfx sounds
     */
    stopAllSfx () {
        this.mapSfx.forEach((v, k) => {
            this._stopSound(k);
        });
        this.mapSfx.clear();
    },

    /**
     *
     */
    resumeEffects () {
        if (this.isCUIOpened) {
            return;
        }

        this.mapSfx.forEach((v,k) => {
            this._resumeSound(k, v.getVolume() * this.volume *  this.sfxVolume);

            if(!this.sfxEnabled) {
                this.muteSfx(v.id);
            } else {
                this.unmuteSfx(v.id);
            }
        });
    },

    pauseEffects () {
        this.mapSfx.forEach((v,k) => {
            this._pauseSound(k);
        });
    },

    /**
     * Mutes the sound, but doesn't pause the playback.
     * @param {number} [audioId] if null, it will mute the music group
     */
    muteMusic (audioId) {
        if (audioId) {
            this._muteSound(audioId);
        } else {

            this.mapMusic.forEach((v) => {
                this._muteSound(v.id);
            });
        }
    },

    /**
     * Mutes the sound, but doesn't pause the playback.
     * @param {number} [audioId] if null, it will unmute the music group
     */
    unmuteMusic (audioId) {
        if (!this.musicEnabled) {
            return;
        }

        if (audioId) {
            this._unmuteSound(audioId);
        } else {
            this.mapMusic.forEach((v) => {
                this._unmuteSound(v.id);
            });
        }
    },

    /**
     * Mutes the effects, but doesn't pause the playback.
     * @param {number} [audioId] if null, it will mute the sound group
     */
    muteSfx (audioId) {
        if (audioId) {
            this._muteSound(audioId);
        } else {
            this.mapSfx.forEach((v) => {
                this._muteSound(v.id);
            });
        }
    },

    /**
     * Mutes the effects, but doesn't pause the playback.
     * @param {number} [audioId] if null, it will unmute the sound group
     */
    unmuteSfx (audioId) {
        if (!this.sfxEnabled) {
            return;
        }

        if (audioId) {
            this._unmuteSound(audioId);
        } else {
            this.mapSfx.forEach((v) => {
                this._unmuteSound(v.id);
            });
        }
    },

    /**
     * Fade a currently playing music between two volumes. calls the onFadeCompleteCallback when complete.
     * @param {Number} from  Volume to fade from (0.0 to 1.0). if null is passed, it will use current volume.
     * @param {Number} to Volume to fade to (0.0 to 1.0). if null is passed, it will use current volume.
     * @param {Number} duration Time in milliseconds to fade.
     * @param {Number} [audioId] The sound ID. If none is passed, all sounds in group will fade.
     * @param {Function} [onFadeCompleteCallback] callback function that is called after fade operation.
     */
    fadeMusic (from, to, duration, audioId, onFadeCompleteCallback) {
        if (assert.numberRange(from, 0, 1) && assert.numberRange(to, 0, 1)) {
            if (audioId) {
                const soundmap = this._getSoundMapEntryByAudioId(audioId, false);

                if (assert.isNull(soundmap)) {
                    cc.warn(`soundmap not found for ${  audioId}`);

                    return;
                }
                // const settings = this._ensureSoundSettings(soundmap.clip, soundmap.sprite);
                from = from === null ? this.getVolume(audioId) : from * soundmap.soundSetting.volume  * this.getMusicVolume();

                soundmap.volume = to === null ? this.getVolume(audioId) : to;

                const musicValueTo = soundmap.getVolume() * this.getMusicVolume() ;

                if (from === musicValueTo) {
                    if (onFadeCompleteCallback) {
                        onFadeCompleteCallback();
                    }
                    return;
                }

                this._fadeSound(from, musicValueTo, duration, audioId, onFadeCompleteCallback);
            } else {
                // todo
                // this.mapMusic.forEach((soundmap) => {
                //     // const settings = this._ensureSoundSettings(soundmap.clip, soundmap.sprite);

                //     soundmap.volume = to;
                //     const musicValue = soundmap.getVolume() * this.getMusicVolume();

                //     this._fadeSound(from, musicValue, duration, soundmap.id, onFadeCompleteCallback);
                // });
            }
        }

    },

    /**
     * Fade a currently playing sound between two volumes. calls the onFadeCompleteCallback when complete.
     * @param {Number} from  Volume to fade from (0.0 to 1.0). if null is passed, it will use current volume.
     * @param {Number} to Volume to fade to (0.0 to 1.0). if null is passed, it will use current volume.
     * @param {Number} duration Time in milliseconds to fade.
     * @param {Number} [audioId] The sound ID. If none is passed, all sounds in group will fade.
     * @param {Function} [onFadeCompleteCallback] callback function that is called after fade operation.
     */
    fadeSound (from, to, duration, audioId, onFadeCompleteCallback) {
        if (assert.numberRange(from, 0, 1) && assert.numberRange(to, 0, 1)) {
            if (audioId) {
                const soundmap = this._getSoundMapEntryByAudioId(audioId, true);

                // const settings = this._ensureSoundSettings(soundmap.clip, soundmap.sprite);
                if (assert.isNull(soundmap)) {
                    cc.warn(`soundmap not found for ${  audioId}`);

                    return;
                }

                from = from === null ? this.getVolume(audioId) : from * soundmap.soundSetting.volume  * this.getSfxVolume();

                soundmap.volume = to === null ? this.getVolume(audioId) : to;

                const effectValue = soundmap.getVolume() * this.getSfxVolume();

                if (from === effectValue) {
                    if (onFadeCompleteCallback) {
                        onFadeCompleteCallback();
                    }
                    return;
                }

                //this._setSoundVolume(audioId, from);
                this._fadeSound(from, effectValue, duration, audioId, onFadeCompleteCallback);
            } else {
                // todo
                // this.mapSfx.forEach((soundmap) => {
                //     // soundmap.clip.volume = to;
                //     soundmap.volume = to;
                //     // const settings = this._ensureSoundSettings(soundmap.clip, soundmap.sprite);
                //     const effectValue = soundmap.getVolume() * this.getSfxVolume();

                //     this._fadeSound(from, effectValue, duration, soundmap.id, onFadeCompleteCallback);
                // });
            }
        }
    },

    /**
     * shorthande function for fading out sound to zero volume, will use current volume of the sound
     * @param {*} duration
     * @param {*} audioId
     * @param {boolean} stopOnEnd stops sound on end of fade out since its fading out to zero volume
     * @param {*} onFadeCompleteCallback
     */
    fadeOutSfx (duration, audioId, stopOnEnd = true, onFadeCompleteCallback = null) {
        this.fadeSound(null, 0, duration, audioId, () => {
            if (onFadeCompleteCallback) {
                onFadeCompleteCallback();
            }

            if (stopOnEnd) {
                this.stopSfx(audioId);
            }
        });
    },
    fadeOutMusic (duration, audioId, stopOnEnd = true, onFadeCompleteCallback = null) {
        this.fadeMusic(null, 0, duration, audioId, () => {
            if (onFadeCompleteCallback) {
                onFadeCompleteCallback();
            }

            if (stopOnEnd) {
                const track = this._getMusicTrackFromId(audioId);

                if (track !== null) {
                    this.stopMusic(track);
                }
            }
        });
    },

    /**
     * shorthand function for fading in sound to volume 1
     * @param {*} duration
     * @param {*} audioId
     * @param {*} onFadeCompleteCallback
     */
    fadeIn (duration, audioId, onFadeCompleteCallback) {
        this.fadeSound(null, 1, duration, audioId, onFadeCompleteCallback);
    },
    fadeInMusic (duration, audioId, onFadeCompleteCallback) {
        this.fadeMusic(null, 1, duration, audioId, onFadeCompleteCallback);
    },

    /**
     * Get/set the rate of playback for a music.
     * @param {Number} rate The rate of playback. 0.5 to 4.0, with 1.0 being normal speed.
     * @param {Number} audioId The sound ID. If none is passed, playback rate of all sounds in group will change.
     */
    setMusicRate (rate, audioId) {
        if (!this.musicEnabled) {
            return;
        }

        if (assert.numberRange(rate, 0.5, 4.0)) {
            if (audioId) {
                this._setSoundRate(rate, audioId);
            } else {
                this.mapMusic.forEach((v) => {
                    this._setSoundRate(rate, v.id);
                });
            }
        }

    },

    /**
     * Get/set the rate of playback for a sound.
     * @param {Number} rate The rate of playback. 0.5 to 4.0, with 1.0 being normal speed.
     * @param {Number} audioId The sound ID. If none is passed, playback rate of all sounds in group will change.
     */
    setSoundRate (rate, audioId) {
        if (!this.sfxEnabled) {
            return;
        }

        if (audioId) {
            this._setSoundRate(rate, audioId);
        } else {
            this.mapSfx.forEach((v,k) => {
                this._setSoundRate(rate, k);
            });
        }
    },

    /**
     * Resets sound group playback rate to 1.0
     */
    resetSoundRate () {
        if (!this.sfxEnabled) {
            return;
        }

        this.mapSfx.forEach((v,k) => {
            this._setSoundRate(1.0, k);
        });
    },

    /**
     * Resets music group playback rate to 1.0
     */
    resetMusicRate () {
        if (!this.musicEnabled) {
            return;
        }

        this.mapMusic.forEach((v) => {
            this._setSoundRate(1.0, v.id);
        });
    },

    /**
     * enable/ disable looping in audio instance
     * @param {*} isLoop
     * @param {*} audioId
     */
    setLoop (isLoop, audioId) {
        const sound = this._getSoundMapEntryByAudioId(audioId);

        if (sound) {
            sound.loop = isLoop;
            this._setLoop(isLoop, audioId);
        }
    },

    /**
     * checks if the audio instance is looping or not
     * @param {*} audioId audio to check if loop is enabled
     * @returns {boolean} true if loop is enabled
     */
    isLoop (audioId) {
        const sound = this._getSoundMapEntryByAudioId(audioId);

        if (sound) {
            return sound.loop;
        }

        return null;
    },

    _isSoundIdSfx (audioID) {
        return typeof this.mapSfx.get(audioID) !== 'undefined';
    },

    _isSoundIdMusic (audioID) {
        for (const value of this.mapMusic.entries()) {
            if (value.id === audioID) {
                return true;
            }
        }

        return false;
    },

    /**
     * gets the music track if the audioId is played as music
     * @param {*} audioID
     * @returns the track index if found, if not returns null
     */
    _getMusicTrackFromId (audioID) {
        for (const [key, value] of this.mapMusic.entries()) {
            if (value.id === audioID) {
                return key;
            }
        }

        return null;
    },

    /**
     * set volume of a specific audio instance relative to its own group volume (effects or volume)
     * @param {Number | cc.AudioClip | string} you can pass an AudioId, cc.AudioClip or spriteName of the audio instance
     * @param {Number} volume
     */
    setSoundVolume (audio, volume = null) {
        if (audio instanceof cc.AudioClip) {
            this.mapMusic.forEach((val) => {
                // eslint-disable-next-line no-underscore-dangle
                if (val.clip._uuid === audio._uuid) {
                    this.setSoundVolume(val.id, volume !== null ? volume : val.volume);
                }
            });

            this.mapSfx.forEach((val) => {
                // eslint-disable-next-line no-underscore-dangle
                if (val.clip._uuid === audio._uuid) {
                    this.setSoundVolume(val.id,  volume !== null ? volume : val.volume);
                }
            });
        } else if (typeof audio === 'string') {
            if (assert.isNull(volume)) {
                cc.warn('volume is null');
            }

            const soundIds = this._getActiveSoundIDsBySpriteName(audio);

            if (soundIds.length > 0) {
                soundIds.forEach((id) => {
                    this.setSoundVolume(id, volume);
                });
            }
        } else if (typeof audio === 'number') {
            if (assert.isNull(volume)) {
                cc.warn('volume is null');
            }

            const isSfx = this._isSoundIdSfx(audio);
            const soundmap = this._getSoundMapEntryByAudioId(audio, isSfx);

            if (!soundmap) {
                return;
            }

            const groupVolume = isSfx ? this.getSfxVolume() : this.getMusicVolume();

            // new volume value is assigned
            soundmap.volume = volume;

            this._setSoundVolume(audio, soundmap.getVolume() * groupVolume);
        }

    },

    /**
     * plays an audioclip and can have its own volume.
     * It is an unmanaged audio playback so it wont be affected by other sfx management functions
     * (ex. Global Volume, Sfx pause on CUI opening)
     * @param {cc.audioClip} audioClip to be played
     * @returns {number} audio ID for the played sfx
     */
    playOneShot (audioClip, volume = 1.0, sideChain) {
        if (assert.isNull(audioClip) || !this.isGameVisible || !this.sfxEnabled) {
            return;
        }

        if (this.volume && this.sfxVolume) {
            this._ensureSoundSettings(audioClip);
            // at least the one shot sound uses its own sound settings
            const effectValue = (this.sfxVolume * this.volume) * this.loadedSoundSettings[audioClip.name].volume * volume;
            return this._playSound(audioClip, false, effectValue, false, null, sideChain);
        }
    },

    playOneShotSprite (audioClip, spriteName, volume = 1.0, sideChain) {
        if (assert.isNull(audioClip) || !this.isGameVisible || !this.sfxEnabled) {
            return;
        }

        if  (this.volume && this.sfxVolume) {
            this._ensureSoundSettings(audioClip, spriteName);
            // at least the one shot sound uses its own sound settings
            const effectValue = (this.sfxVolume * this.volume) * this.loadedSoundSettings[`sprite:${spriteName}`].volume * volume;

            return this._playAudioSprite(audioClip, spriteName, false, effectValue, false, null, sideChain);
        }
    },

    /**
     * checks if audio instance is playing or not
     * @param {cc.AudioClip | Number} audio if number passed, it will check if the specific audio
     * instance is  currently playing. if cc.AudioClip is passed, if will check if any instance of it is playing
     */
    isPlaying (audio) {
        return this._isPlaying(audio);
    },

    /**
     * Check if a music track is playing an audio file
     * @param {Number} track track number
     */
    isMusicPlaying (track = 0) {
        if (assert.numberRange(track, 0, this.maxMusicSimultaneously - 1)) {

            return this._isPlaying(this.mapMusic.get(track).id);
        }

        return null;
    },

    /**
     * check if audioclip instance is loaded and ready to use
\     * @param {cc.AudioClip} audioClip
     */
    isLoaded (audioClip) {
        if (audioClip instanceof cc.AudioClip) {
            return this._isLoaded(audioClip);
        }

        return false;
    },

    /**
     * gets current volume of an audioclip or audio instance
     * @param {cc.AudioClip | number} audio
     */
    getVolume (audio) {
        return this._getVolume(audio);
    },

    /**
     *
     * @param {cc.AudioClip} audioClip audio file to be preloaded
     * @param {*} json json config file. used by HOWLER
     * @returns {Promise} if loaded succesfully, returns a resolved Promise
     */
    preloadAudio (audioClip, json = null) {

        if (json !== null) {
            this._handleAudioSpriteLoad(audioClip, json);
        }

        return this._preloadAudio(audioClip, json);
    },

    changeAudioClip(soundMapEntry, audioClip) {

    },

    //#region Functions to be overridden

    /** set sound volume with the specified Audio ID */
    // eslint-disable-next-line no-unused-vars
    _setSoundVolume (audio, volume) {
        throw new Error('not yet implemented');
    },
    // eslint-disable-next-line no-unused-vars
    _resumeSound (audioId) {
        throw new Error('not yet implemented');
    },
    // eslint-disable-next-line no-unused-vars
    _pauseSound (audioId) {
        throw new Error('not yet implemented');
    },
    /** should return audio id */
    // eslint-disable-next-line no-unused-vars
    _playSound (audioclip, isLoop, volume, onAudioEndCallback) {
        throw new Error('not yet implemented');
    },
    // eslint-disable-next-line no-unused-vars
    _stopSound (audioId) {
        throw new Error('not yet implemented');
    },
    // eslint-disable-next-line no-unused-vars
    _stopSoundByAudioClip (audio) {
        throw new Error('not yet implemented');
    },
    // eslint-disable-next-line no-unused-vars
    _onAudioEnd (audioId, onAudioEndCallback) {
        throw new Error('not yet implemented');
    },
    _stopAllSounds () {
        throw new Error('not yet implemented');
    },
    // eslint-disable-next-line no-unused-vars
    _setGlobalVolume (value) {
        throw new Error('not yet implemented');
    },
    // eslint-disable-next-line no-unused-vars
    _muteSound (audio) {
        throw new Error('not yet implemented');
    },
    // eslint-disable-next-line no-unused-vars
    _muteMusic (audioId) {
        throw new Error('not yet implemented');
    },
    // eslint-disable-next-line no-unused-vars
    _unmuteSound (audioId) {
        throw new Error('not yet implemented');
    },
    // eslint-disable-next-line no-unused-vars
    _unmuteMusic (audioId) {
        throw new Error('not yet implemented');
    },
    // eslint-disable-next-line no-unused-vars
    _fadeSound (from, to, duration, audioId, onFadeCompleteCallback) {
        throw new Error('not yet implemented');
    },
    // eslint-disable-next-line no-unused-vars
    _setSoundRate (rate, audioId) {
        throw new Error('not yet implemented');
    },
    // eslint-disable-next-line no-unused-vars
    _setMusicRate (rate, audioId) {
        throw new Error('not yet implemented');
    },
    // eslint-disable-next-line no-unused-vars
    _setLoop (isLoop, audioId) {
        throw new Error('not yet implemented');
    },
    // eslint-disable-next-line no-unused-vars
    _isLoop (audioId) {
        throw new Error('not yet implemented');
    },
    // eslint-disable-next-line no-unused-vars
    _isPlaying (audio) {
        throw new Error('not yet implemented');
    },
    // eslint-disable-next-line no-unused-vars
    _isLoaded (audio) {
        throw new Error('not yet implemented');
    },
    // eslint-disable-next-line no-unused-vars
    _preloadAudio (file, json) {
        throw new Error('not yet implemented');
    },
    // eslint-disable-next-line no-unused-vars
    _playAudioSprite (file, spriteName, loop, volume, onAudioEndCallback) {
        throw new Error('not yet implemented');
    },
    // eslint-disable-next-line no-unused-vars
    _getActiveSoundIDsBySpriteName (spriteName) {
        throw new Error('not yet implemented');
    },
    // eslint-disable-next-line no-unused-vars
    _getVolume (audio) {
        throw new Error('not yet implemented');
    }
    //#endregion
});
